import React from 'react'
import styled from 'styled-components'
import { BLUE, LIGHTERGRAY } from '../../../styles/colors.style'
import { isMobile } from '../../../services/breakpoints.service'
import Carousel from '../../../components/sliders/carousel.component.jsx'

const StyledContainer = styled.div`
	position: relative;
`

const StyledOriginalImg = styled.img`
	border-radius: 5px;
	${({ show }) => (show ? '' : 'display: none;')}
`

const StyledThumbnailContainer = styled.div`
	background-color: ${LIGHTERGRAY};
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
	height: 62px;
	padding-bottom: 15px;
	padding-left: 3px;
	padding-top: 3px;
	display: flex;
`

const StyledThumbnail = styled.img`
	cursor: pointer;
	margin: 4px;
	max-height: 50px;
	max-width: 50px;
	border-bottom: 4px solid transparent;
	&.selected {
		border-bottom-color: ${BLUE};
		border-bottom-left-radius: 4px;
		border-bottom-right-radius: 4px;
	}
`

const StyledNumberOfPhotos = styled.span`
	background: rgba(200, 200, 200, 0.5);
	border-radius: 5px;
	bottom: 15px;
	color: white;
	font-size: 2rem;
	left: 15px;
	padding: 5px 10px;
	position: absolute;
`

const StyledMobileImg = styled.img`
	width: 100%;
	border-radius: 5px;
`

class Gallery extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			selectedImage: 0
		}

		this.renderView = renderView.bind(this)
		this.renderMobileView = renderMobileView.bind(this)
	}

	render() {
		const { className } = this.props

		return (
			<StyledContainer className={className}>
				{isMobile() ? this.renderMobileView() : this.renderView()}
			</StyledContainer>
		)
	}
}

function renderMobileView() {
	const { items } = this.props
	const showNumberOfPhotos = items.length > 1

	return (
		<React.Fragment>
			<Carousel
				style={{ position: 'relative' }}
				dots={true}
				infinite={false}
				autoplay={false}>
				{items.map(({ original }, index) => (
					<StyledMobileImg src={original} key={index} />
				))}
			</Carousel>
			{showNumberOfPhotos ? (
				<StyledNumberOfPhotos>{items.length} Fotos</StyledNumberOfPhotos>
			) : null}
		</React.Fragment>
	)
}

function renderView() {
	const { items } = this.props
	const { selectedImage } = this.state

	return (
		<React.Fragment>
			{items.map(({ original }, index) => (
				<StyledOriginalImg
					key={index}
					show={index === selectedImage}
					src={original}
				/>
			))}
			<StyledThumbnailContainer>
				{items.map(({ thumbnail }, index) => (
					<StyledThumbnail
						className={index === selectedImage ? 'selected' : ''}
						src={thumbnail}
						key={index}
						onMouseEnter={() => this.setState({ selectedImage: index })}
					/>
				))}
			</StyledThumbnailContainer>
		</React.Fragment>
	)
}

export default Gallery
